/**
 * This file is generated from Unicode Scripts.txt (Unicode 15.1).
 *
 * Source: https://www.unicode.org/Public/UCD/latest/ucd/Scripts.txt
 * Licensed under the Unicode License: https://www.unicode.org/license.html
 *
 * Do not edit manually. Regenerate with: scripts/generate-script-ranges.ts
 */

/** A Unicode code point range with an associated script. */
export type ScriptRange = {
  start: number;
  end: number;
  script: string;
};

/** A list of sorted, non-overlapping Unicode code point ranges covering 22 scripts. */
export const scriptRanges: ScriptRange[] = [
  { start: 0x0000, end: 0x0040, script: 'Common' },
  { start: 0x0041, end: 0x005a, script: 'Latin' },
  { start: 0x005b, end: 0x0060, script: 'Common' },
  { start: 0x0061, end: 0x007a, script: 'Latin' },
  { start: 0x007b, end: 0x00a9, script: 'Common' },
  { start: 0x00aa, end: 0x00aa, script: 'Latin' },
  { start: 0x00ab, end: 0x00b9, script: 'Common' },
  { start: 0x00ba, end: 0x00ba, script: 'Latin' },
  { start: 0x00bb, end: 0x00bf, script: 'Common' },
  { start: 0x00c0, end: 0x00d6, script: 'Latin' },
  { start: 0x00d7, end: 0x00d7, script: 'Common' },
  { start: 0x00d8, end: 0x00f6, script: 'Latin' },
  { start: 0x00f7, end: 0x00f7, script: 'Common' },
  { start: 0x00f8, end: 0x02b8, script: 'Latin' },
  { start: 0x02b9, end: 0x02df, script: 'Common' },
  { start: 0x02e0, end: 0x02e4, script: 'Latin' },
  { start: 0x02e5, end: 0x02e9, script: 'Common' },
  { start: 0x02ec, end: 0x02ff, script: 'Common' },
  { start: 0x0300, end: 0x036f, script: 'Inherited' },
  { start: 0x0370, end: 0x0373, script: 'Greek' },
  { start: 0x0374, end: 0x0374, script: 'Common' },
  { start: 0x0375, end: 0x0377, script: 'Greek' },
  { start: 0x037a, end: 0x037d, script: 'Greek' },
  { start: 0x037e, end: 0x037e, script: 'Common' },
  { start: 0x037f, end: 0x037f, script: 'Greek' },
  { start: 0x0384, end: 0x0384, script: 'Greek' },
  { start: 0x0385, end: 0x0385, script: 'Common' },
  { start: 0x0386, end: 0x0386, script: 'Greek' },
  { start: 0x0387, end: 0x0387, script: 'Common' },
  { start: 0x0388, end: 0x038a, script: 'Greek' },
  { start: 0x038c, end: 0x038c, script: 'Greek' },
  { start: 0x038e, end: 0x03a1, script: 'Greek' },
  { start: 0x03a3, end: 0x03e1, script: 'Greek' },
  { start: 0x03f0, end: 0x03ff, script: 'Greek' },
  { start: 0x0400, end: 0x0484, script: 'Cyrillic' },
  { start: 0x0485, end: 0x0486, script: 'Inherited' },
  { start: 0x0487, end: 0x052f, script: 'Cyrillic' },
  { start: 0x0531, end: 0x0556, script: 'Armenian' },
  { start: 0x0559, end: 0x058a, script: 'Armenian' },
  { start: 0x058d, end: 0x058f, script: 'Armenian' },
  { start: 0x0591, end: 0x05c7, script: 'Hebrew' },
  { start: 0x05d0, end: 0x05ea, script: 'Hebrew' },
  { start: 0x05ef, end: 0x05f4, script: 'Hebrew' },
  { start: 0x0600, end: 0x0604, script: 'Arabic' },
  { start: 0x0605, end: 0x0605, script: 'Common' },
  { start: 0x0606, end: 0x060b, script: 'Arabic' },
  { start: 0x060c, end: 0x060c, script: 'Common' },
  { start: 0x060d, end: 0x061a, script: 'Arabic' },
  { start: 0x061b, end: 0x061b, script: 'Common' },
  { start: 0x061c, end: 0x061e, script: 'Arabic' },
  { start: 0x061f, end: 0x061f, script: 'Common' },
  { start: 0x0620, end: 0x063f, script: 'Arabic' },
  { start: 0x0640, end: 0x0640, script: 'Common' },
  { start: 0x0641, end: 0x064a, script: 'Arabic' },
  { start: 0x064b, end: 0x0655, script: 'Inherited' },
  { start: 0x0656, end: 0x066f, script: 'Arabic' },
  { start: 0x0670, end: 0x0670, script: 'Inherited' },
  { start: 0x0671, end: 0x06dc, script: 'Arabic' },
  { start: 0x06dd, end: 0x06dd, script: 'Common' },
  { start: 0x06de, end: 0x06ff, script: 'Arabic' },
  { start: 0x0750, end: 0x077f, script: 'Arabic' },
  { start: 0x0870, end: 0x088e, script: 'Arabic' },
  { start: 0x0890, end: 0x0891, script: 'Arabic' },
  { start: 0x0898, end: 0x08e1, script: 'Arabic' },
  { start: 0x08e2, end: 0x08e2, script: 'Common' },
  { start: 0x08e3, end: 0x08ff, script: 'Arabic' },
  { start: 0x0900, end: 0x0950, script: 'Devanagari' },
  { start: 0x0951, end: 0x0954, script: 'Inherited' },
  { start: 0x0955, end: 0x0963, script: 'Devanagari' },
  { start: 0x0964, end: 0x0965, script: 'Common' },
  { start: 0x0966, end: 0x097f, script: 'Devanagari' },
  { start: 0x0980, end: 0x0983, script: 'Bengali' },
  { start: 0x0985, end: 0x098c, script: 'Bengali' },
  { start: 0x098f, end: 0x0990, script: 'Bengali' },
  { start: 0x0993, end: 0x09a8, script: 'Bengali' },
  { start: 0x09aa, end: 0x09b0, script: 'Bengali' },
  { start: 0x09b2, end: 0x09b2, script: 'Bengali' },
  { start: 0x09b6, end: 0x09b9, script: 'Bengali' },
  { start: 0x09bc, end: 0x09c4, script: 'Bengali' },
  { start: 0x09c7, end: 0x09c8, script: 'Bengali' },
  { start: 0x09cb, end: 0x09ce, script: 'Bengali' },
  { start: 0x09d7, end: 0x09d7, script: 'Bengali' },
  { start: 0x09dc, end: 0x09dd, script: 'Bengali' },
  { start: 0x09df, end: 0x09e3, script: 'Bengali' },
  { start: 0x09e6, end: 0x09fe, script: 'Bengali' },
  { start: 0x0a01, end: 0x0a03, script: 'Gurmukhi' },
  { start: 0x0a05, end: 0x0a0a, script: 'Gurmukhi' },
  { start: 0x0a0f, end: 0x0a10, script: 'Gurmukhi' },
  { start: 0x0a13, end: 0x0a28, script: 'Gurmukhi' },
  { start: 0x0a2a, end: 0x0a30, script: 'Gurmukhi' },
  { start: 0x0a32, end: 0x0a33, script: 'Gurmukhi' },
  { start: 0x0a35, end: 0x0a36, script: 'Gurmukhi' },
  { start: 0x0a38, end: 0x0a39, script: 'Gurmukhi' },
  { start: 0x0a3c, end: 0x0a3c, script: 'Gurmukhi' },
  { start: 0x0a3e, end: 0x0a42, script: 'Gurmukhi' },
  { start: 0x0a47, end: 0x0a48, script: 'Gurmukhi' },
  { start: 0x0a4b, end: 0x0a4d, script: 'Gurmukhi' },
  { start: 0x0a51, end: 0x0a51, script: 'Gurmukhi' },
  { start: 0x0a59, end: 0x0a5c, script: 'Gurmukhi' },
  { start: 0x0a5e, end: 0x0a5e, script: 'Gurmukhi' },
  { start: 0x0a66, end: 0x0a76, script: 'Gurmukhi' },
  { start: 0x0a81, end: 0x0a83, script: 'Gujarati' },
  { start: 0x0a85, end: 0x0a8d, script: 'Gujarati' },
  { start: 0x0a8f, end: 0x0a91, script: 'Gujarati' },
  { start: 0x0a93, end: 0x0aa8, script: 'Gujarati' },
  { start: 0x0aaa, end: 0x0ab0, script: 'Gujarati' },
  { start: 0x0ab2, end: 0x0ab3, script: 'Gujarati' },
  { start: 0x0ab5, end: 0x0ab9, script: 'Gujarati' },
  { start: 0x0abc, end: 0x0ac5, script: 'Gujarati' },
  { start: 0x0ac7, end: 0x0ac9, script: 'Gujarati' },
  { start: 0x0acb, end: 0x0acd, script: 'Gujarati' },
  { start: 0x0ad0, end: 0x0ad0, script: 'Gujarati' },
  { start: 0x0ae0, end: 0x0ae3, script: 'Gujarati' },
  { start: 0x0ae6, end: 0x0af1, script: 'Gujarati' },
  { start: 0x0af9, end: 0x0aff, script: 'Gujarati' },
  { start: 0x0b82, end: 0x0b83, script: 'Tamil' },
  { start: 0x0b85, end: 0x0b8a, script: 'Tamil' },
  { start: 0x0b8e, end: 0x0b90, script: 'Tamil' },
  { start: 0x0b92, end: 0x0b95, script: 'Tamil' },
  { start: 0x0b99, end: 0x0b9a, script: 'Tamil' },
  { start: 0x0b9c, end: 0x0b9c, script: 'Tamil' },
  { start: 0x0b9e, end: 0x0b9f, script: 'Tamil' },
  { start: 0x0ba3, end: 0x0ba4, script: 'Tamil' },
  { start: 0x0ba8, end: 0x0baa, script: 'Tamil' },
  { start: 0x0bae, end: 0x0bb9, script: 'Tamil' },
  { start: 0x0bbe, end: 0x0bc2, script: 'Tamil' },
  { start: 0x0bc6, end: 0x0bc8, script: 'Tamil' },
  { start: 0x0bca, end: 0x0bcd, script: 'Tamil' },
  { start: 0x0bd0, end: 0x0bd0, script: 'Tamil' },
  { start: 0x0bd7, end: 0x0bd7, script: 'Tamil' },
  { start: 0x0be6, end: 0x0bfa, script: 'Tamil' },
  { start: 0x0c00, end: 0x0c0c, script: 'Telugu' },
  { start: 0x0c0e, end: 0x0c10, script: 'Telugu' },
  { start: 0x0c12, end: 0x0c28, script: 'Telugu' },
  { start: 0x0c2a, end: 0x0c39, script: 'Telugu' },
  { start: 0x0c3c, end: 0x0c44, script: 'Telugu' },
  { start: 0x0c46, end: 0x0c48, script: 'Telugu' },
  { start: 0x0c4a, end: 0x0c4d, script: 'Telugu' },
  { start: 0x0c55, end: 0x0c56, script: 'Telugu' },
  { start: 0x0c58, end: 0x0c5a, script: 'Telugu' },
  { start: 0x0c5d, end: 0x0c5d, script: 'Telugu' },
  { start: 0x0c60, end: 0x0c63, script: 'Telugu' },
  { start: 0x0c66, end: 0x0c6f, script: 'Telugu' },
  { start: 0x0c77, end: 0x0c7f, script: 'Telugu' },
  { start: 0x0c80, end: 0x0c8c, script: 'Kannada' },
  { start: 0x0c8e, end: 0x0c90, script: 'Kannada' },
  { start: 0x0c92, end: 0x0ca8, script: 'Kannada' },
  { start: 0x0caa, end: 0x0cb3, script: 'Kannada' },
  { start: 0x0cb5, end: 0x0cb9, script: 'Kannada' },
  { start: 0x0cbc, end: 0x0cc4, script: 'Kannada' },
  { start: 0x0cc6, end: 0x0cc8, script: 'Kannada' },
  { start: 0x0cca, end: 0x0ccd, script: 'Kannada' },
  { start: 0x0cd5, end: 0x0cd6, script: 'Kannada' },
  { start: 0x0cdd, end: 0x0cde, script: 'Kannada' },
  { start: 0x0ce0, end: 0x0ce3, script: 'Kannada' },
  { start: 0x0ce6, end: 0x0cef, script: 'Kannada' },
  { start: 0x0cf1, end: 0x0cf3, script: 'Kannada' },
  { start: 0x0d00, end: 0x0d0c, script: 'Malayalam' },
  { start: 0x0d0e, end: 0x0d10, script: 'Malayalam' },
  { start: 0x0d12, end: 0x0d44, script: 'Malayalam' },
  { start: 0x0d46, end: 0x0d48, script: 'Malayalam' },
  { start: 0x0d4a, end: 0x0d4f, script: 'Malayalam' },
  { start: 0x0d54, end: 0x0d63, script: 'Malayalam' },
  { start: 0x0d66, end: 0x0d7f, script: 'Malayalam' },
  { start: 0x0e01, end: 0x0e3a, script: 'Thai' },
  { start: 0x0e3f, end: 0x0e3f, script: 'Common' },
  { start: 0x0e40, end: 0x0e5b, script: 'Thai' },
  { start: 0x0fd5, end: 0x0fd8, script: 'Common' },
  { start: 0x10a0, end: 0x10c5, script: 'Georgian' },
  { start: 0x10c7, end: 0x10c7, script: 'Georgian' },
  { start: 0x10cd, end: 0x10cd, script: 'Georgian' },
  { start: 0x10d0, end: 0x10fa, script: 'Georgian' },
  { start: 0x10fb, end: 0x10fb, script: 'Common' },
  { start: 0x10fc, end: 0x10ff, script: 'Georgian' },
  { start: 0x1100, end: 0x11ff, script: 'Hangul' },
  { start: 0x16eb, end: 0x16ed, script: 'Common' },
  { start: 0x1735, end: 0x1736, script: 'Common' },
  { start: 0x1802, end: 0x1803, script: 'Common' },
  { start: 0x1805, end: 0x1805, script: 'Common' },
  { start: 0x1ab0, end: 0x1ace, script: 'Inherited' },
  { start: 0x1c80, end: 0x1c88, script: 'Cyrillic' },
  { start: 0x1c90, end: 0x1cba, script: 'Georgian' },
  { start: 0x1cbd, end: 0x1cbf, script: 'Georgian' },
  { start: 0x1cd0, end: 0x1cd2, script: 'Inherited' },
  { start: 0x1cd3, end: 0x1cd3, script: 'Common' },
  { start: 0x1cd4, end: 0x1ce0, script: 'Inherited' },
  { start: 0x1ce1, end: 0x1ce1, script: 'Common' },
  { start: 0x1ce2, end: 0x1ce8, script: 'Inherited' },
  { start: 0x1ce9, end: 0x1cec, script: 'Common' },
  { start: 0x1ced, end: 0x1ced, script: 'Inherited' },
  { start: 0x1cee, end: 0x1cf3, script: 'Common' },
  { start: 0x1cf4, end: 0x1cf4, script: 'Inherited' },
  { start: 0x1cf5, end: 0x1cf7, script: 'Common' },
  { start: 0x1cf8, end: 0x1cf9, script: 'Inherited' },
  { start: 0x1cfa, end: 0x1cfa, script: 'Common' },
  { start: 0x1d00, end: 0x1d25, script: 'Latin' },
  { start: 0x1d26, end: 0x1d2a, script: 'Greek' },
  { start: 0x1d2b, end: 0x1d2b, script: 'Cyrillic' },
  { start: 0x1d2c, end: 0x1d5c, script: 'Latin' },
  { start: 0x1d5d, end: 0x1d61, script: 'Greek' },
  { start: 0x1d62, end: 0x1d65, script: 'Latin' },
  { start: 0x1d66, end: 0x1d6a, script: 'Greek' },
  { start: 0x1d6b, end: 0x1d77, script: 'Latin' },
  { start: 0x1d78, end: 0x1d78, script: 'Cyrillic' },
  { start: 0x1d79, end: 0x1dbe, script: 'Latin' },
  { start: 0x1dbf, end: 0x1dbf, script: 'Greek' },
  { start: 0x1dc0, end: 0x1dff, script: 'Inherited' },
  { start: 0x1e00, end: 0x1eff, script: 'Latin' },
  { start: 0x1f00, end: 0x1f15, script: 'Greek' },
  { start: 0x1f18, end: 0x1f1d, script: 'Greek' },
  { start: 0x1f20, end: 0x1f45, script: 'Greek' },
  { start: 0x1f48, end: 0x1f4d, script: 'Greek' },
  { start: 0x1f50, end: 0x1f57, script: 'Greek' },
  { start: 0x1f59, end: 0x1f59, script: 'Greek' },
  { start: 0x1f5b, end: 0x1f5b, script: 'Greek' },
  { start: 0x1f5d, end: 0x1f5d, script: 'Greek' },
  { start: 0x1f5f, end: 0x1f7d, script: 'Greek' },
  { start: 0x1f80, end: 0x1fb4, script: 'Greek' },
  { start: 0x1fb6, end: 0x1fc4, script: 'Greek' },
  { start: 0x1fc6, end: 0x1fd3, script: 'Greek' },
  { start: 0x1fd6, end: 0x1fdb, script: 'Greek' },
  { start: 0x1fdd, end: 0x1fef, script: 'Greek' },
  { start: 0x1ff2, end: 0x1ff4, script: 'Greek' },
  { start: 0x1ff6, end: 0x1ffe, script: 'Greek' },
  { start: 0x2000, end: 0x200b, script: 'Common' },
  { start: 0x200c, end: 0x200d, script: 'Inherited' },
  { start: 0x200e, end: 0x2064, script: 'Common' },
  { start: 0x2066, end: 0x2070, script: 'Common' },
  { start: 0x2071, end: 0x2071, script: 'Latin' },
  { start: 0x2074, end: 0x207e, script: 'Common' },
  { start: 0x207f, end: 0x207f, script: 'Latin' },
  { start: 0x2080, end: 0x208e, script: 'Common' },
  { start: 0x2090, end: 0x209c, script: 'Latin' },
  { start: 0x20a0, end: 0x20c0, script: 'Common' },
  { start: 0x20d0, end: 0x20f0, script: 'Inherited' },
  { start: 0x2100, end: 0x2125, script: 'Common' },
  { start: 0x2126, end: 0x2126, script: 'Greek' },
  { start: 0x2127, end: 0x2129, script: 'Common' },
  { start: 0x212a, end: 0x212b, script: 'Latin' },
  { start: 0x212c, end: 0x2131, script: 'Common' },
  { start: 0x2132, end: 0x2132, script: 'Latin' },
  { start: 0x2133, end: 0x214d, script: 'Common' },
  { start: 0x214e, end: 0x214e, script: 'Latin' },
  { start: 0x214f, end: 0x215f, script: 'Common' },
  { start: 0x2160, end: 0x2188, script: 'Latin' },
  { start: 0x2189, end: 0x218b, script: 'Common' },
  { start: 0x2190, end: 0x2426, script: 'Common' },
  { start: 0x2440, end: 0x244a, script: 'Common' },
  { start: 0x2460, end: 0x27ff, script: 'Common' },
  { start: 0x2900, end: 0x2b73, script: 'Common' },
  { start: 0x2b76, end: 0x2b95, script: 'Common' },
  { start: 0x2b97, end: 0x2bff, script: 'Common' },
  { start: 0x2c60, end: 0x2c7f, script: 'Latin' },
  { start: 0x2d00, end: 0x2d25, script: 'Georgian' },
  { start: 0x2d27, end: 0x2d27, script: 'Georgian' },
  { start: 0x2d2d, end: 0x2d2d, script: 'Georgian' },
  { start: 0x2de0, end: 0x2dff, script: 'Cyrillic' },
  { start: 0x2e00, end: 0x2e5d, script: 'Common' },
  { start: 0x2e80, end: 0x2e99, script: 'Han' },
  { start: 0x2e9b, end: 0x2ef3, script: 'Han' },
  { start: 0x2f00, end: 0x2fd5, script: 'Han' },
  { start: 0x2ff0, end: 0x3004, script: 'Common' },
  { start: 0x3005, end: 0x3005, script: 'Han' },
  { start: 0x3006, end: 0x3006, script: 'Common' },
  { start: 0x3007, end: 0x3007, script: 'Han' },
  { start: 0x3008, end: 0x3020, script: 'Common' },
  { start: 0x3021, end: 0x3029, script: 'Han' },
  { start: 0x302a, end: 0x302d, script: 'Inherited' },
  { start: 0x302e, end: 0x302f, script: 'Hangul' },
  { start: 0x3030, end: 0x3037, script: 'Common' },
  { start: 0x3038, end: 0x303b, script: 'Han' },
  { start: 0x303c, end: 0x303f, script: 'Common' },
  { start: 0x3041, end: 0x3096, script: 'Hiragana' },
  { start: 0x3099, end: 0x309a, script: 'Inherited' },
  { start: 0x309b, end: 0x309c, script: 'Common' },
  { start: 0x309d, end: 0x309f, script: 'Hiragana' },
  { start: 0x30a0, end: 0x30a0, script: 'Common' },
  { start: 0x30a1, end: 0x30fa, script: 'Katakana' },
  { start: 0x30fb, end: 0x30fc, script: 'Common' },
  { start: 0x30fd, end: 0x30ff, script: 'Katakana' },
  { start: 0x3131, end: 0x318e, script: 'Hangul' },
  { start: 0x3190, end: 0x319f, script: 'Common' },
  { start: 0x31c0, end: 0x31e3, script: 'Common' },
  { start: 0x31ef, end: 0x31ef, script: 'Common' },
  { start: 0x31f0, end: 0x31ff, script: 'Katakana' },
  { start: 0x3200, end: 0x321e, script: 'Hangul' },
  { start: 0x3220, end: 0x325f, script: 'Common' },
  { start: 0x3260, end: 0x327e, script: 'Hangul' },
  { start: 0x327f, end: 0x32cf, script: 'Common' },
  { start: 0x32d0, end: 0x32fe, script: 'Katakana' },
  { start: 0x32ff, end: 0x32ff, script: 'Common' },
  { start: 0x3300, end: 0x3357, script: 'Katakana' },
  { start: 0x3358, end: 0x33ff, script: 'Common' },
  { start: 0x3400, end: 0x4dbf, script: 'Han' },
  { start: 0x4dc0, end: 0x4dff, script: 'Common' },
  { start: 0x4e00, end: 0x9fff, script: 'Han' },
  { start: 0xa640, end: 0xa69f, script: 'Cyrillic' },
  { start: 0xa700, end: 0xa721, script: 'Common' },
  { start: 0xa722, end: 0xa787, script: 'Latin' },
  { start: 0xa788, end: 0xa78a, script: 'Common' },
  { start: 0xa78b, end: 0xa7ca, script: 'Latin' },
  { start: 0xa7d0, end: 0xa7d1, script: 'Latin' },
  { start: 0xa7d3, end: 0xa7d3, script: 'Latin' },
  { start: 0xa7d5, end: 0xa7d9, script: 'Latin' },
  { start: 0xa7f2, end: 0xa7ff, script: 'Latin' },
  { start: 0xa830, end: 0xa839, script: 'Common' },
  { start: 0xa8e0, end: 0xa8ff, script: 'Devanagari' },
  { start: 0xa92e, end: 0xa92e, script: 'Common' },
  { start: 0xa960, end: 0xa97c, script: 'Hangul' },
  { start: 0xa9cf, end: 0xa9cf, script: 'Common' },
  { start: 0xab30, end: 0xab5a, script: 'Latin' },
  { start: 0xab5b, end: 0xab5b, script: 'Common' },
  { start: 0xab5c, end: 0xab64, script: 'Latin' },
  { start: 0xab65, end: 0xab65, script: 'Greek' },
  { start: 0xab66, end: 0xab69, script: 'Latin' },
  { start: 0xab6a, end: 0xab6b, script: 'Common' },
  { start: 0xac00, end: 0xd7a3, script: 'Hangul' },
  { start: 0xd7b0, end: 0xd7c6, script: 'Hangul' },
  { start: 0xd7cb, end: 0xd7fb, script: 'Hangul' },
  { start: 0xf900, end: 0xfa6d, script: 'Han' },
  { start: 0xfa70, end: 0xfad9, script: 'Han' },
  { start: 0xfb00, end: 0xfb06, script: 'Latin' },
  { start: 0xfb13, end: 0xfb17, script: 'Armenian' },
  { start: 0xfb1d, end: 0xfb36, script: 'Hebrew' },
  { start: 0xfb38, end: 0xfb3c, script: 'Hebrew' },
  { start: 0xfb3e, end: 0xfb3e, script: 'Hebrew' },
  { start: 0xfb40, end: 0xfb41, script: 'Hebrew' },
  { start: 0xfb43, end: 0xfb44, script: 'Hebrew' },
  { start: 0xfb46, end: 0xfb4f, script: 'Hebrew' },
  { start: 0xfb50, end: 0xfbc2, script: 'Arabic' },
  { start: 0xfbd3, end: 0xfd3d, script: 'Arabic' },
  { start: 0xfd3e, end: 0xfd3f, script: 'Common' },
  { start: 0xfd40, end: 0xfd8f, script: 'Arabic' },
  { start: 0xfd92, end: 0xfdc7, script: 'Arabic' },
  { start: 0xfdcf, end: 0xfdcf, script: 'Arabic' },
  { start: 0xfdf0, end: 0xfdff, script: 'Arabic' },
  { start: 0xfe00, end: 0xfe0f, script: 'Inherited' },
  { start: 0xfe10, end: 0xfe19, script: 'Common' },
  { start: 0xfe20, end: 0xfe2d, script: 'Inherited' },
  { start: 0xfe2e, end: 0xfe2f, script: 'Cyrillic' },
  { start: 0xfe30, end: 0xfe52, script: 'Common' },
  { start: 0xfe54, end: 0xfe66, script: 'Common' },
  { start: 0xfe68, end: 0xfe6b, script: 'Common' },
  { start: 0xfe70, end: 0xfe74, script: 'Arabic' },
  { start: 0xfe76, end: 0xfefc, script: 'Arabic' },
  { start: 0xfeff, end: 0xfeff, script: 'Common' },
  { start: 0xff01, end: 0xff20, script: 'Common' },
  { start: 0xff21, end: 0xff3a, script: 'Latin' },
  { start: 0xff3b, end: 0xff40, script: 'Common' },
  { start: 0xff41, end: 0xff5a, script: 'Latin' },
  { start: 0xff5b, end: 0xff65, script: 'Common' },
  { start: 0xff66, end: 0xff6f, script: 'Katakana' },
  { start: 0xff70, end: 0xff70, script: 'Common' },
  { start: 0xff71, end: 0xff9d, script: 'Katakana' },
  { start: 0xff9e, end: 0xff9f, script: 'Common' },
  { start: 0xffa0, end: 0xffbe, script: 'Hangul' },
  { start: 0xffc2, end: 0xffc7, script: 'Hangul' },
  { start: 0xffca, end: 0xffcf, script: 'Hangul' },
  { start: 0xffd2, end: 0xffd7, script: 'Hangul' },
  { start: 0xffda, end: 0xffdc, script: 'Hangul' },
  { start: 0xffe0, end: 0xffe6, script: 'Common' },
  { start: 0xffe8, end: 0xffee, script: 'Common' },
  { start: 0xfff9, end: 0xfffd, script: 'Common' },
  { start: 0x10100, end: 0x10102, script: 'Common' },
  { start: 0x10107, end: 0x10133, script: 'Common' },
  { start: 0x10137, end: 0x1013f, script: 'Common' },
  { start: 0x10140, end: 0x1018e, script: 'Greek' },
  { start: 0x10190, end: 0x1019c, script: 'Common' },
  { start: 0x101a0, end: 0x101a0, script: 'Greek' },
  { start: 0x101d0, end: 0x101fc, script: 'Common' },
  { start: 0x101fd, end: 0x101fd, script: 'Inherited' },
  { start: 0x102e0, end: 0x102e0, script: 'Inherited' },
  { start: 0x102e1, end: 0x102fb, script: 'Common' },
  { start: 0x10780, end: 0x10785, script: 'Latin' },
  { start: 0x10787, end: 0x107b0, script: 'Latin' },
  { start: 0x107b2, end: 0x107ba, script: 'Latin' },
  { start: 0x10e60, end: 0x10e7e, script: 'Arabic' },
  { start: 0x10efd, end: 0x10eff, script: 'Arabic' },
  { start: 0x1133b, end: 0x1133b, script: 'Inherited' },
  { start: 0x11b00, end: 0x11b09, script: 'Devanagari' },
  { start: 0x11fc0, end: 0x11ff1, script: 'Tamil' },
  { start: 0x11fff, end: 0x11fff, script: 'Tamil' },
  { start: 0x16fe2, end: 0x16fe3, script: 'Han' },
  { start: 0x16ff0, end: 0x16ff1, script: 'Han' },
  { start: 0x1aff0, end: 0x1aff3, script: 'Katakana' },
  { start: 0x1aff5, end: 0x1affb, script: 'Katakana' },
  { start: 0x1affd, end: 0x1affe, script: 'Katakana' },
  { start: 0x1b000, end: 0x1b000, script: 'Katakana' },
  { start: 0x1b001, end: 0x1b11f, script: 'Hiragana' },
  { start: 0x1b120, end: 0x1b122, script: 'Katakana' },
  { start: 0x1b132, end: 0x1b132, script: 'Hiragana' },
  { start: 0x1b150, end: 0x1b152, script: 'Hiragana' },
  { start: 0x1b155, end: 0x1b155, script: 'Katakana' },
  { start: 0x1b164, end: 0x1b167, script: 'Katakana' },
  { start: 0x1bca0, end: 0x1bca3, script: 'Common' },
  { start: 0x1cf00, end: 0x1cf2d, script: 'Inherited' },
  { start: 0x1cf30, end: 0x1cf46, script: 'Inherited' },
  { start: 0x1cf50, end: 0x1cfc3, script: 'Common' },
  { start: 0x1d000, end: 0x1d0f5, script: 'Common' },
  { start: 0x1d100, end: 0x1d126, script: 'Common' },
  { start: 0x1d129, end: 0x1d166, script: 'Common' },
  { start: 0x1d167, end: 0x1d169, script: 'Inherited' },
  { start: 0x1d16a, end: 0x1d17a, script: 'Common' },
  { start: 0x1d17b, end: 0x1d182, script: 'Inherited' },
  { start: 0x1d183, end: 0x1d184, script: 'Common' },
  { start: 0x1d185, end: 0x1d18b, script: 'Inherited' },
  { start: 0x1d18c, end: 0x1d1a9, script: 'Common' },
  { start: 0x1d1aa, end: 0x1d1ad, script: 'Inherited' },
  { start: 0x1d1ae, end: 0x1d1ea, script: 'Common' },
  { start: 0x1d200, end: 0x1d245, script: 'Greek' },
  { start: 0x1d2c0, end: 0x1d2d3, script: 'Common' },
  { start: 0x1d2e0, end: 0x1d2f3, script: 'Common' },
  { start: 0x1d300, end: 0x1d356, script: 'Common' },
  { start: 0x1d360, end: 0x1d378, script: 'Common' },
  { start: 0x1d400, end: 0x1d454, script: 'Common' },
  { start: 0x1d456, end: 0x1d49c, script: 'Common' },
  { start: 0x1d49e, end: 0x1d49f, script: 'Common' },
  { start: 0x1d4a2, end: 0x1d4a2, script: 'Common' },
  { start: 0x1d4a5, end: 0x1d4a6, script: 'Common' },
  { start: 0x1d4a9, end: 0x1d4ac, script: 'Common' },
  { start: 0x1d4ae, end: 0x1d4b9, script: 'Common' },
  { start: 0x1d4bb, end: 0x1d4bb, script: 'Common' },
  { start: 0x1d4bd, end: 0x1d4c3, script: 'Common' },
  { start: 0x1d4c5, end: 0x1d505, script: 'Common' },
  { start: 0x1d507, end: 0x1d50a, script: 'Common' },
  { start: 0x1d50d, end: 0x1d514, script: 'Common' },
  { start: 0x1d516, end: 0x1d51c, script: 'Common' },
  { start: 0x1d51e, end: 0x1d539, script: 'Common' },
  { start: 0x1d53b, end: 0x1d53e, script: 'Common' },
  { start: 0x1d540, end: 0x1d544, script: 'Common' },
  { start: 0x1d546, end: 0x1d546, script: 'Common' },
  { start: 0x1d54a, end: 0x1d550, script: 'Common' },
  { start: 0x1d552, end: 0x1d6a5, script: 'Common' },
  { start: 0x1d6a8, end: 0x1d7cb, script: 'Common' },
  { start: 0x1d7ce, end: 0x1d7ff, script: 'Common' },
  { start: 0x1df00, end: 0x1df1e, script: 'Latin' },
  { start: 0x1df25, end: 0x1df2a, script: 'Latin' },
  { start: 0x1e030, end: 0x1e06d, script: 'Cyrillic' },
  { start: 0x1e08f, end: 0x1e08f, script: 'Cyrillic' },
  { start: 0x1ec71, end: 0x1ecb4, script: 'Common' },
  { start: 0x1ed01, end: 0x1ed3d, script: 'Common' },
  { start: 0x1ee00, end: 0x1ee03, script: 'Arabic' },
  { start: 0x1ee05, end: 0x1ee1f, script: 'Arabic' },
  { start: 0x1ee21, end: 0x1ee22, script: 'Arabic' },
  { start: 0x1ee24, end: 0x1ee24, script: 'Arabic' },
  { start: 0x1ee27, end: 0x1ee27, script: 'Arabic' },
  { start: 0x1ee29, end: 0x1ee32, script: 'Arabic' },
  { start: 0x1ee34, end: 0x1ee37, script: 'Arabic' },
  { start: 0x1ee39, end: 0x1ee39, script: 'Arabic' },
  { start: 0x1ee3b, end: 0x1ee3b, script: 'Arabic' },
  { start: 0x1ee42, end: 0x1ee42, script: 'Arabic' },
  { start: 0x1ee47, end: 0x1ee47, script: 'Arabic' },
  { start: 0x1ee49, end: 0x1ee49, script: 'Arabic' },
  { start: 0x1ee4b, end: 0x1ee4b, script: 'Arabic' },
  { start: 0x1ee4d, end: 0x1ee4f, script: 'Arabic' },
  { start: 0x1ee51, end: 0x1ee52, script: 'Arabic' },
  { start: 0x1ee54, end: 0x1ee54, script: 'Arabic' },
  { start: 0x1ee57, end: 0x1ee57, script: 'Arabic' },
  { start: 0x1ee59, end: 0x1ee59, script: 'Arabic' },
  { start: 0x1ee5b, end: 0x1ee5b, script: 'Arabic' },
  { start: 0x1ee5d, end: 0x1ee5d, script: 'Arabic' },
  { start: 0x1ee5f, end: 0x1ee5f, script: 'Arabic' },
  { start: 0x1ee61, end: 0x1ee62, script: 'Arabic' },
  { start: 0x1ee64, end: 0x1ee64, script: 'Arabic' },
  { start: 0x1ee67, end: 0x1ee6a, script: 'Arabic' },
  { start: 0x1ee6c, end: 0x1ee72, script: 'Arabic' },
  { start: 0x1ee74, end: 0x1ee77, script: 'Arabic' },
  { start: 0x1ee79, end: 0x1ee7c, script: 'Arabic' },
  { start: 0x1ee7e, end: 0x1ee7e, script: 'Arabic' },
  { start: 0x1ee80, end: 0x1ee89, script: 'Arabic' },
  { start: 0x1ee8b, end: 0x1ee9b, script: 'Arabic' },
  { start: 0x1eea1, end: 0x1eea3, script: 'Arabic' },
  { start: 0x1eea5, end: 0x1eea9, script: 'Arabic' },
  { start: 0x1eeab, end: 0x1eebb, script: 'Arabic' },
  { start: 0x1eef0, end: 0x1eef1, script: 'Arabic' },
  { start: 0x1f000, end: 0x1f02b, script: 'Common' },
  { start: 0x1f030, end: 0x1f093, script: 'Common' },
  { start: 0x1f0a0, end: 0x1f0ae, script: 'Common' },
  { start: 0x1f0b1, end: 0x1f0bf, script: 'Common' },
  { start: 0x1f0c1, end: 0x1f0cf, script: 'Common' },
  { start: 0x1f0d1, end: 0x1f0f5, script: 'Common' },
  { start: 0x1f100, end: 0x1f1ad, script: 'Common' },
  { start: 0x1f1e6, end: 0x1f1ff, script: 'Common' },
  { start: 0x1f200, end: 0x1f200, script: 'Hiragana' },
  { start: 0x1f201, end: 0x1f202, script: 'Common' },
  { start: 0x1f210, end: 0x1f23b, script: 'Common' },
  { start: 0x1f240, end: 0x1f248, script: 'Common' },
  { start: 0x1f250, end: 0x1f251, script: 'Common' },
  { start: 0x1f260, end: 0x1f265, script: 'Common' },
  { start: 0x1f300, end: 0x1f6d7, script: 'Common' },
  { start: 0x1f6dc, end: 0x1f6ec, script: 'Common' },
  { start: 0x1f6f0, end: 0x1f6fc, script: 'Common' },
  { start: 0x1f700, end: 0x1f776, script: 'Common' },
  { start: 0x1f77b, end: 0x1f7d9, script: 'Common' },
  { start: 0x1f7e0, end: 0x1f7eb, script: 'Common' },
  { start: 0x1f7f0, end: 0x1f7f0, script: 'Common' },
  { start: 0x1f800, end: 0x1f80b, script: 'Common' },
  { start: 0x1f810, end: 0x1f847, script: 'Common' },
  { start: 0x1f850, end: 0x1f859, script: 'Common' },
  { start: 0x1f860, end: 0x1f887, script: 'Common' },
  { start: 0x1f890, end: 0x1f8ad, script: 'Common' },
  { start: 0x1f8b0, end: 0x1f8b1, script: 'Common' },
  { start: 0x1f900, end: 0x1fa53, script: 'Common' },
  { start: 0x1fa60, end: 0x1fa6d, script: 'Common' },
  { start: 0x1fa70, end: 0x1fa7c, script: 'Common' },
  { start: 0x1fa80, end: 0x1fa88, script: 'Common' },
  { start: 0x1fa90, end: 0x1fabd, script: 'Common' },
  { start: 0x1fabf, end: 0x1fac5, script: 'Common' },
  { start: 0x1face, end: 0x1fadb, script: 'Common' },
  { start: 0x1fae0, end: 0x1fae8, script: 'Common' },
  { start: 0x1faf0, end: 0x1faf8, script: 'Common' },
  { start: 0x1fb00, end: 0x1fb92, script: 'Common' },
  { start: 0x1fb94, end: 0x1fbca, script: 'Common' },
  { start: 0x1fbf0, end: 0x1fbf9, script: 'Common' },
  { start: 0x20000, end: 0x2a6df, script: 'Han' },
  { start: 0x2a700, end: 0x2b739, script: 'Han' },
  { start: 0x2b740, end: 0x2b81d, script: 'Han' },
  { start: 0x2b820, end: 0x2cea1, script: 'Han' },
  { start: 0x2ceb0, end: 0x2ebe0, script: 'Han' },
  { start: 0x2ebf0, end: 0x2ee5d, script: 'Han' },
  { start: 0x2f800, end: 0x2fa1d, script: 'Han' },
  { start: 0x30000, end: 0x3134a, script: 'Han' },
  { start: 0x31350, end: 0x323af, script: 'Han' },
  { start: 0xe0001, end: 0xe0001, script: 'Common' },
  { start: 0xe0020, end: 0xe007f, script: 'Common' },
  { start: 0xe0100, end: 0xe01ef, script: 'Inherited' },
] as const;
